export default function RenterAgreementAcceptanceSection({
  values,
  onToggle,
  warningsRequired = false,
  disabled = false,
}) {
  return (
    <section className="space-y-3 rounded-[2rem] border border-slate-200 bg-slate-50 p-5">
      <div>
        <p className="text-xs font-semibold uppercase tracking-[0.22em] text-rose-500">
          Agreement Terms
        </p>
        <p className="mt-3 text-sm leading-6 text-slate-600">
          Review each item below before you continue. These acknowledgements are required for the
          renter-side arrangement summary.
        </p>
      </div>

      <label className="flex items-start gap-3 text-sm text-slate-700">
        <input
          type="checkbox"
          checked={Boolean(values.acknowledge_operating_mode)}
          onChange={(event) => onToggle("acknowledge_operating_mode", event.target.checked)}
          className="mt-0.5"
          disabled={disabled}
        />
        <span>I understand whether I am operating under the host salon or independently.</span>
      </label>

      <label className="flex items-start gap-3 text-sm text-slate-700">
        <input
          type="checkbox"
          checked={Boolean(values.acknowledge_client_ownership)}
          onChange={(event) => onToggle("acknowledge_client_ownership", event.target.checked)}
          className="mt-0.5"
          disabled={disabled}
        />
        <span>I understand whether clients are salon-owned or independent-owned.</span>
      </label>

      <label className="flex items-start gap-3 text-sm text-slate-700">
        <input
          type="checkbox"
          checked={Boolean(values.acknowledge_payment_terms)}
          onChange={(event) => onToggle("acknowledge_payment_terms", event.target.checked)}
          className="mt-0.5"
          disabled={disabled}
        />
        <span>I understand the pricing, deposit, and payment terms shown here.</span>
      </label>

      <label className="flex items-start gap-3 text-sm text-slate-700">
        <input
          type="checkbox"
          checked={Boolean(values.acknowledge_platform_disclaimer)}
          onChange={(event) =>
            onToggle("acknowledge_platform_disclaimer", event.target.checked)
          }
          className="mt-0.5"
          disabled={disabled}
        />
        <span>
          I understand this platform helps structure and document the relationship, but does not
          itself guarantee legal classification compliance.
        </span>
      </label>

      {warningsRequired ? (
        <label className="flex items-start gap-3 text-sm text-slate-700">
          <input
            type="checkbox"
            checked={Boolean(values.acknowledge_warnings)}
            onChange={(event) => onToggle("acknowledge_warnings", event.target.checked)}
            className="mt-0.5"
            disabled={disabled}
          />
          <span>I reviewed the current notices and understand they require acknowledgement.</span>
        </label>
      ) : null}

      <label className="flex items-start gap-3 text-sm text-slate-700">
        <input
          type="checkbox"
          checked={Boolean(values.accept_terms)}
          onChange={(event) => onToggle("accept_terms", event.target.checked)}
          className="mt-0.5"
          disabled={disabled}
        />
        <span>I understand the agreement version or rental terms I am accepting.</span>
      </label>
    </section>
  );
}
